import { CommunityFeatureFlags, CommunitySettings } from '../../models/community/community-settings.model';

/**
 * Resolves a school's feature switches once, in one place.
 *
 * A MISSING flag means ON: a school that flips to Modern gets the whole experience and
 * then turns off what it does not want from Community Settings. Only an explicit
 * `false` disables a feature.
 *
 * This rule used to be re-typed in the shell, the post page and the settings screen.
 * Three copies is how `features.polls` ended up honoured by the composer and ignored by
 * the post card (QA defect B): the flag was only ever consulted where somebody
 * remembered to consult it. Deriving it here means a new screen inherits the rule.
 */
export function novaFeatures(
  settings: Pick<CommunitySettings, 'features'> | null | undefined
): Required<CommunityFeatureFlags> {
  const flags = settings?.features ?? {};
  const on = (value: boolean | undefined) => value !== false;

  return {
    leaderboard: on(flags.leaderboard),
    events: on(flags.events),
    askAi: on(flags.askAi),
    digest: on(flags.digest),
    polls: on(flags.polls),
    reactions: on(flags.reactions),
    onboarding: on(flags.onboarding),
    healthCard: on(flags.healthCard),
    bestAnswer: on(flags.bestAnswer),
  };
}
